<!--<div class="loading">Loading&#8230;</div>-->

<div *ngIf="active" class="spinner">
  <div class="double-bounce1"></div>
  <div class="double-bounce2"></div>
</div>
